import React, { useState, useEffect } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';
import FiltersPartial from './FiltersPartial.js';
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import PageContentWrapper from "../../components/PageContentWrapper";
import Modal from 'react-bootstrap/Modal';
import { selectQueryParams, updateQueryParams, resetQueryParams } from "../../ui/customerListingReducer.js";
import { useSelector, useDispatch } from "react-redux";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const PaymentModal = (props) => {
  const dispatch = useDispatch();
  const [ payPartnerBillApi ] = getApi('payPartnerBill')
  const [paymentObj , setPaymentObj] = useState({})
  const selectedQueryParams = useSelector(selectQueryParams)

  let changePaymentObj = (event, key) => {
    setPaymentObj((prevState)=>{
    return {...prevState, [key]: event.target.value}
    })
  }

  const makePayment = async () => {
    try {
      const response = await payPartnerBillApi({...paymentObj, role_name: 'cp', user_id: props.updateDetails?.user_id, id: props.updateDetails?.id}).unwrap();
      props.updateShowState()
      toast.success("Payment done successfully")
      dispatch(updateQueryParams(selectedQueryParams));
      // dispatch(resetQueryParams());
    } catch (error) {
      toast.error(error.data?.message || "Something went wrong!")
    }
  }

  return <Modal show={props.updateDetails !== null} onHide={() => props.updateShowState()}>
    <Modal.Header closeButton>
      <Modal.Title>Payment to CP {props.updateDetails?.user_name}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Col>Bill No. : {props.updateDetails?.bill_no}</Col>
        <Col>Bill Amount : {props.updateDetails?.amount}</Col>
      </Row>
      <br/>
      <Row>
        <Col>Bill due Amount : {props.updateDetails?.unpaid_amount}</Col>
        <Col>Total Paid Amount : {props.updateDetails?.amount - props.updateDetails?.unpaid_amount}</Col>
      </Row>
      <br/>
      <Row>
        <Col>
          <label htmlFor="name" className="form-label">Amount to Pay</label>
          <input
            id="to_pay_amount"
            value={paymentObj.amount}
            onChange={(e) => changePaymentObj(e, 'amount')}
            type="number"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter the amount to pay'
            aria-describedby='name_help'
          />
        </Col>
        <Col>
          <label htmlFor="name" className="form-label">Payment Document</label>
          <input
            id="name"
            value={paymentObj.tally_transaction_number}
            onChange={(e) => changePaymentObj(e, 'tally_transaction_number')}
            type="text"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Payment Document No.'
            aria-describedby='name_help'
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <label htmlFor="name" className="form-label">Remarks</label>
          <textarea
            id="name"
            value={paymentObj.remarks}
            onChange={(e) => changePaymentObj(e, 'remarks')}
            className="form-control form-control-sm font-size-12"
            placeholder='Remarks'
            aria-describedby='name_help'
          />
        </Col>
      </Row>
      {/*{JSON.stringify(props)}*/}
    </Modal.Body>
    <Modal.Footer>
      <button className='btn bg-danger text-white' onClick={()=> props.updateShowState()}>
        Close
      </button>
      <button className='btn bg-success text-white' onClick={()=> makePayment()}>
        Process Payment
      </button>
    </Modal.Footer>
  </Modal>
}

export default PaymentModal;
